export default {
    verifyUserInput: (addressVerification) => {
        if (!addressVerification?.Address && addressVerification?.VerifiedAddresses?.length === 1)
            return addressVerification.VerifiedAddresses[0];
        return null;
    },
};
